import { render } from "./ChallengeDetail.vue?vue&type=template&id=020b929e&scoped=true"
import script from "./ChallengeDetail.vue?vue&type=script&lang=js"
export * from "./ChallengeDetail.vue?vue&type=script&lang=js"

import "./ChallengeDetail.vue?vue&type=style&index=0&id=020b929e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-020b929e"

export default script